import React, { useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  PaginationItem,
} from "@mui/material";
import { Pagination } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme";
import { blogCards } from "./blogPost";
import { useLocation } from "react-router-dom";

export default function BlogCards() {
  const [page, setPage] = useState(1);
  const location = useLocation();
  const heading = location.state?.heading || false;

  const blogsPerPage = 3;
  const totalPages = Math.ceil(blogCards.length / blogsPerPage); // Example

  const startIndex = (page - 1) * blogsPerPage;
  const currentBlogs = blogCards.slice(startIndex, startIndex + blogsPerPage);

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" }); // optional: scroll back to top
  };

  return (
    <ThemeProvider theme={theme}>
      {heading && (
        <Box
          sx={{
            maxWidth: "fullWidth",
            height: "40vh",
            backgroundColor: "#f9f8ffff",
            textAlign: "center",
            // display: "flex",
            alignItems: "center",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <Typography
            variant="h2"
            sx={{ mb: 1, fontWeight: 550, color: "primary.main" }}
          >
            Insights & Ideas
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "#747474ff", lineHeight: "30px", p: 1 }}
          >
            Discover how to take control of your cloud costs with practical
            strategies, expert insights, <br />
            and real-world stories, helping you save smarter and scale faster
          </Typography>
        </Box>
      )}
      <Box sx={{ p: { xs: 2, md: 6 } }}>
        {/* Section Title */}
        <Typography
          variant="h4"
          gutterBottom
          sx={{ mb: 4, color: "primary.main", fontWeight: "bold", ml: "10%" }}
        >
          Latest Blogs
        </Typography>

        <Box
          sx={{
            p: { xs: 0, md: 6, lg: 0 },
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Grid container spacing={5} sx={{ maxWidth: 1200, mx: "auto" }}>
            {currentBlogs.map((blog) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={blog.id}>
                <Card
                  sx={{
                    borderRadius: 3,
                    backgroundColor: "#fafbfbff",
                    // boxShadow: 1,
                    width: "100%",
                    maxWidth: 360,
                    mx: "auto",
                    height: "100%",
                    boxSizing: "border-box",
                    overflow: "hidden",
                    transition: "transform 0.5s, opacity 0.2s",
                    "&:hover": {
                      transform: "scale(1.03)",
                      // border: "2.4px solid #fff",
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    height="185"
                    image={blog.img}
                    alt={blog.title}
                  />
                  <CardContent>
                    <Button
                      href={blog.href}
                      sx={{
                        textAlign: "left",
                        p: 0,
                        backgroundColor: "transparent",
                      }}
                    >
                      <Typography
                        variant="h6"
                        component="div"
                        gutterBottom
                        sx={{ fontWeight: "bold" }}
                      >
                        {blog.title}
                      </Typography>
                    </Button>
                    <Typography variant="body2" color="text.secondary">
                      {blog.desc}
                    </Typography>
                  </CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between", // spreads them apart
                      px: 2,
                      mb: 1,
                    }}
                  >
                    <Button
                      href={blog.href}
                      sx={{
                        fontFamily: '"Inter", sans-serif',
                        fontWeight: 550,
                        textTransform: "none",
                        fontSize: "1em",
                        p: 0,
                      }}
                    >
                      Read more
                    </Button>

                    <Typography
                      variant="button"
                      sx={{
                        color: "text.secondary",
                        fontSize: "0.9em",
                      }}
                    >
                      {blog.date}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            siblingCount={2}
            boundaryCount={1}
            renderItem={(item) => (
              <PaginationItem
                {...item}
                sx={{
                  color: "primary.main",
                  "&:hover": {
                    backgroundColor: "#c6e3f2ff",
                    borderColor: "black",
                  },
                  "&.Mui-selected": {
                    // backgroundColor: "primary.main",
                    background:
                      "linear-gradient(135deg, #188ccaff 0%, #6E73F2 100%)",
                    color: "white",
                    borderRadius: "50%",
                  },
                }}
              />
            )}
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
